export default {
    network: {
        connectedToInternet: "Assurez-vous d'être connecté à Internet.",
        connectionRetrieved: 'Connexion avec le serveur récupérée.',
        unableToConnect: 'Impossible de se connecter au serveur.',
    },
    general: {
        actions: 'Actions',
        add: 'Ajouter',
        allTab: 'Tous',
        back: 'Retour',
        btnRefresh: 'Rafraîchir',
        bulkAction: 'Actions de masse',
        bulkActions: 'Actions de masse',
        cancel: 'Annuler',
        clickHere: 'Cliquez ici',
        close: 'Fermer',
        comingSoon: 'Bientôt disponible...',
        create: 'Créer',
        delete: 'Supprimer',
        download: 'Télécharger',
        edit: 'Modifier',
        email: 'Courriel',
        error: 'Erreur',
        export: 'Exporter',
        help: 'Aide',
        import: 'Importer',
        loading: 'Chargement',
        logout: 'Déconnexion',
        next: 'Suivant',
        none: 'Aucun',
        noResults: 'Aucun résultat.',
        notSent: 'Non envoyé',
        patience: "C'est presque fini. Je le jure.",
        previous: 'Précédent',
        remove: 'Retirer',
        save: 'Sauvegarder',
        search: 'Rechercher...',
        select: 'Sélectionner...',
        send: 'Envoyer',
        sent: 'Envoyé',
        settings: 'Paramètres',
        sms: 'SMS',
        success: 'Succès',
        upload: 'Téléverser',
        warning: 'Avertissement',
    },
    confirmModal: {
        yes: 'Oui',
        no: 'Non',
    },
    mainNav: {
        appointments: 'Rendez-vous',
        automations: 'Automatisations',
        campaigns: 'Campagnes',
        chat: 'Chat',
        contacts: 'Contacts',
        imports: 'Historique d\'imports',
        payments: 'Paiements',
        accounts: 'Comptes',
        importResult: 'Résult d\'importation',
        tooltips: {
            comingSoon: 'Bientôt disponible',
        },
        support: 'Contacter le support',
    },
    maintenance: 'Maintenance en cours. De retour sous peu.',
    date: {
        today: 'Aujourd\'hui',
        yesterday: 'Hier',
    },
    errors: {
        notFound: {
            title: 'Erreur. Page introuvable.',
            description: 'La page que vous recherchez n\'existe pas.',
            button: 'Faites moi sortir d\'ici!',
        },
        unknown: 'Une erreur inconnue est survenue.',
        validationError: 'Une erreur de validation est survenue.',
        validationErrorTitle: 'Erreur de validation',
    },
    notifications: {
        newMessage: 'Nouveau message',
        paymentReceivedTitle: 'Paiement reçu',
        paymentReceivedBody: '{contact} a effectué un paiement. | {contact} a effectué le paiement de la facture #{number}.',
    },
    weekdays: {
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche',
    },
    phoneStatus: {
        valid: 'Valide',
        notValidated: 'Non validé',
        invalid: 'Invalide',
    },
    civility: {
        mr: 'M.',
        ms: 'Mme',
        miss: 'Mlle',
        dr: 'Dr',
        esq: 'Me',
    },
    pagination: {
        results: 'Résultats {start}-{end} de {total}',
    },
    trial: {
        smsLimitExceeded: 'La limite mensuelle de SMS du compte a été atteinte.',
    },
    countries: {
        ca: 'Canada',
        us: 'États-Unis',
    },
    provinces: {
        ab: 'Alberta',
        bc: 'Colombie-Britannique',
        mb: 'Manitoba',
        nb: 'Nouveau-Brunswick',
        nl: 'Terre-Neuve-et-Labrador',
        ns: 'Territoires du Nord-Ouest',
        nt: 'Nouvelle-Écosse',
        nu: 'Nunavut',
        on: 'Ontario',
        pe: 'Île-du-Prince-Édouard',
        qc: 'Québec',
        sk: 'Saskatchewan',
        yt: 'Yukon',
    },
    states: {
        al: 'Alabama',
        ak: 'Alaska',
        az: 'Arizona',
        ar: 'Arkansas',
        ca: 'Californie',
        co: 'Colorado',
        ct: 'Connecticut',
        de: 'Delaware',
        fl: 'Floride',
        ga: 'Géorgie',
        hi: 'Hawaï',
        id: 'Idaho',
        il: 'Illinois',
        in: 'Indiana',
        ia: 'Iowa',
        ks: 'Kansas',
        ky: 'Kentucky',
        la: 'Louisiane',
        me: 'Maine',
        md: 'Maryland',
        ma: 'Massachusetts',
        mi: 'Michigan',
        mn: 'Minnesota',
        ms: 'Mississippi',
        mo: 'Missouri',
        mt: 'Montana',
        ne: 'Nebraska',
        nv: 'Nevada',
        nh: 'New Hampshire',
        nm: 'Nouveau-Mexique',
        nj: 'New Jersey',
        ny: 'New York',
        nc: 'Caroline du Nord',
        nd: 'Dakota du Nord',
        oh: 'Ohio',
        ok: 'Oklahoma',
        or: 'Oregon',
        pa: 'Pennsylvanie',
        ri: 'Rhode Island',
        sc: 'Caroline du Sud',
        sd: 'Dakota du Sud',
        tn: 'Tennessee',
        tx: 'Texas',
        ut: 'Utah',
        vt: 'Vermont',
        va: 'Virginie',
        wa: 'Washington',
        wv: 'Virginie-Occidentale',
        wi: 'Wisconsin',
        wy: 'Wyoming',
    },
    disabled: {
        missingValidProviderPhoneTooltip: 'Vous devez avoir au moins un téléphone de fournisseur valide pour effectuer cette action',
    },
};
